import { markItUpConfig } from './markitup_config.js'

$.fn.extend({ exists: function() { return $(this).length>0 }})

$.extend($.expr[":"], {
  blank: function(a) { return !$.trim('' + a.value) },
  filled: function(a) { return !!$.trim('' + a.value) },
  unchecked: function(a) { return !a.checked },
  email: function(a) { return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/mig.test(a.value) }
});

$.ajaxSetup({
  statusCode: {
    401: function(){
      PopUp.show('.popup.sign-in', '/popups/signin');
    }
  }
});

window.MP = window.MP || {};

MP.GlobalProperties = function () { this.init() }
MP.GlobalProperties.prototype = {
  init: function() {
    this.Page = $('body').attr('class');
  }
}

MP.GlobalHandler = function () { this.init() }
MP.GlobalHandler.prototype = {
  init: function() {
    $(document).on('mousedown', function(e) {
      if (e.isImmediatePropagationStopped()) return;

      GlobalHandler.closePopUps(e);
      GlobalHandler.closeDropDowns(e);
      GlobalHandler.closeComboboxes(e);
    });
  },

  closeDropDowns: function(e) {
    DropDowns.hide(e, 'userInfoHandler');
    DropDowns.hide(e, 'userActionsHandler');
    DropDowns.hide(e, 'loginThroughSocialNetworksToggle');
  },

  closePopUps: function(e) {
    PopUp.hide('.popup.sign-up');
    PopUp.hide('.popup.sign-in');
    PopUp.hide('.popup.new-message');
    PopUp.hide('.popup.special-offer');
    PopUp.hide('.popup.new-ticket');
    PopUp.hide('.popup.forgot');
  },

  closeComboboxes: function(e) {
    Combobox.hide(e, '.combobox.blog-id');
    Combobox.hide(e, '.combobox.warns-sidebar');
    Combobox.hide(e, '.combobox.warns-intext');
    Combobox.hide(e, '.combobox.video-type');
    Combobox.hide(e, '.combobox.poker-type');
    Combobox.hide(e, '.combobox.game-type');
    Combobox.hide(e, '.combobox.players');
    Combobox.hide(e, '.combobox.limits');
  }
}

MP.DropDowns = function () { this.init() }
MP.DropDowns.prototype = {
  init: function() {
    this.userInfo = $('.header > .user > .logged-in > .info-dropdown');
    this.userInfo.click( function(e) { e.stopPropagation() } )
    this.userInfoShows = $('.header > .user > .logged-in > .info > .username');
    this.userInfoShows.bind('click', {action:'show'}, $.proxy(this, 'userInfoHandler'));

    this.userActions = $('.header > .sidebar > .actions-dropdown');
    this.userActions.click( function(e) { e.stopPropagation() } )
    this.userActionsShows = $('.header > .sidebar > .actions > .toggler');
    this.userActionsHides = $('.header > .sidebar > .actions-dropdown > ul > li > .toggler');
    this.userActionsShows.bind('click', {action:'show'}, $.proxy(this, 'userActionsHandler'));
    this.userActionsHides.bind('click', {action:'hide'}, $.proxy(this, 'userActionsHandler'));

    this.signinThroughSocialNetworksToggler = $('.header > .user > .login .through-social-networks .toggler');
    this.signinThroughSocialNetworksList = $('.header > .user > .login .through-social-networks > .networks-list');
    this.signinThroughSocialNetworksToggler.bind('click', $.proxy(this, 'loginThroughSocialNetworksToggle'));
  },

  show: function(e, dropdown) {
    e.data = { action: 'show' };
    this[dropdown](e);
  },

  hide: function(e, dropdown) {
    e.data = { action: 'hide' };
    this[dropdown](e);
  },

  userInfoHandler: function(e) {
    var action = e.data.action;

    if (action == 'show') {
      this.userInfo.css({display:'block', opacity:0})
                   .animate({opacity: 1}, 500);
      return;
    }

    if ((action == 'hide') && ( this.userInfo.is(':visible') )) {
      this.userInfo.animate({opacity: 0}, 500, function() {
        $(this).hide();
      });
    }
  },

  userActionsHandler: function(e) {
    var action = e.data.action;

    if (action == 'show') {
      this.userActions.css({display:'block', opacity:0})
                      .animate({opacity: 1}, 500);
      return;
    }

    if ((action == 'hide') && ( this.userActions.is(':visible') )) {
      this.userActions.animate({opacity: 0}, 500, function() {
        $(this).hide();
      });
    }
  },

  loginThroughSocialNetworksToggle: function(e) {
    if (!e.data) {
      var action = this.signinThroughSocialNetworksList.is(':hidden') ? 'show' : 'hide';
    } else {
      var action = e.data.action;
    }

    if (action == 'show') {
      this.signinThroughSocialNetworksList.stop(true,true).css({display:'block', opacity:0}).animate({opacity: 1}, 500);
      return;
    }

    if (action == 'hide') {
      this.signinThroughSocialNetworksList.stop(true,true).animate({opacity: 0}, 500, function() {
        $(this).hide();
      });
    }
  }
}

MP.PopUp = function () { this.init() }
MP.PopUp.prototype = {
  init: function() {
    this.makeOverlay();
  },

  makeOverlay: function() {
    var html = '<div class="overlay"/>';
    this.overlay = $(html).appendTo( $('footer') );
  },

  create: function(id, url) {
    $.ajax({
      type: "GET",
      url: url,
      dataType: "html",
      success: function( data ) {
        if ($(id).length) return;
        $(data).appendTo( $('body') );
        $('body').on('mousedown', id, function(e) { e.stopImmediatePropagation() });
        PopUp.show(id, url);
        $(id).trigger('created');
      }
    });
  },

  destroy: function(id, url) {
    var object = $(id);
    object.remove();
  },

  show: function(id, url, showOverlay) {

    var object = $(id);

    if (!object.length) { this.create(id, url); return }
    if (object.is(':animated') || this.overlay.is(':animated')) return;

    this.overlay.show().fadeTo(100, 1, function() {
      object.show().fadeTo(100, 1, function(){
        object.addClass('visible').trigger('shown');
      });
    });
  },

  hide: function(id, leaveOverlay) {
    var object = $(id);
    var _this = this;

    if (!object.exists() || object.is(':hidden') || object.is(':animated') || this.overlay.is('animated')) return;

    object.animate({opacity: 0}, 400, function() {
      $(this).hide().trigger('hidden');
      if (!leaveOverlay) {
        _this.overlay.animate({opacity: '0'}, 400, function() {
          $(this).hide();
        });
      }
    });
  }
}

MP.Combobox = function () { this.init() }
MP.Combobox.prototype = {
  init: function() {
    this.makeCombobox('.combobox.blog-id');
    this.makeCombobox('.combobox.warns-sidebar');
    this.makeCombobox('.combobox.warns-intext');
    this.makeCombobox('.combobox.choose-category');
    this.makeCombobox('.combobox.day');
    this.makeCombobox('.combobox.month');
    this.makeCombobox('.combobox.hours');
    this.makeCombobox('.combobox.minutes');
  },

  show: function(e, combobox) {
    var list = $(combobox).find('.values-list');
    list.slideUp('fast');
  },

  hide: function(e, combobox) {
    if (combobox == '.autocomplete') {
      var targetIsNotInsideAutocomlete = !$(e.target).parents('.autocomplete').length,
          targetIsNotInputField = !$(e.target).is('input#to');

      if ( targetIsNotInsideAutocomlete && targetIsNotInputField ) {
        $('.autocomplete').hide();
      }
      return;
    }

    var list = $(combobox).find('.values-list');
    list.slideUp('fast');
  },

  makeCombobox: function(comboboxClassName) {
    var wrapper = $(comboboxClassName);
    var current = wrapper.find('.current');
    var list = wrapper.find('.values-list');
    var select = wrapper.find('select');
    var anchors = list.find('li > a');
    var value = wrapper.find('input:hidden');

    current.on('click', function(e) {
      e.preventDefault();
    });

    anchors.on('click', function(e) {
      e.preventDefault();
    });

    current.on('mousedown', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      list.slideToggle('fast');
    });

    anchors.on('mousedown', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var self = $(this);
      value.val( self.attr('id') );

      current.html( self.html() );
      current.addClass('changed');

      list.slideToggle('fast');
    });

    select.on('change click', function() {
      var selected = select.find('option:selected');

      $(this).siblings('.current').html( selected.text() ).addClass('changed');
    });
  }
}

MP.SignUp = function () { this.init() }
MP.SignUp.prototype = {
  init: function() {
    this.showers = '.header .login .sign-up, .post .sign-up, .wrapper .sign-up';
    this.hiders = '.popup.sign-up > a.close, .overlay';
    this.className = '.popup.sign-up';

    $('body').delegate(this.showers, 'click touchstart', $.proxy(this, 'show'));
    $('body').delegate(this.hiders, 'click touchstart', $.proxy(this, 'hide'));
    $('body').delegate(this.className, 'shown', $.proxy(this, 'shown'));
    $('body').on('input[type=submit]', $('.sign-up.popup form'), $.proxy(this, 'submit'));
  },

  show: function(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();
    PopUp.show(this.className, '/popups/signup');
  },

  hide: function(e) {
    if (e) e.preventDefault();

    PopUp.hide(this.className);
  },

  shown: function() {
    this.form = $(this.className);
    this.form.unbind().bind('submit', $.proxy(this, 'submit'));
  },

  validate: function() {
    Forms.hideErrors(this.form);

    var login = this.form.find('input.login');
    var mail = this.form.find('input.email');
    var pass = this.form.find('input.password');
    var passAgain = this.form.find('input.password-confirm');

    if (login.val().length < 2) { Forms.showError(login, 'min'); return }
    if (login.val().length > 50) { Forms.showError(login, 'max'); return }
    if (login.is(':blank')) { Forms.showError(login, 'blank'); return }

    if (!mail.is(':email')) { Forms.showError(mail, 'email'); return }
    if (mail.is(':blank')) { Forms.showError(mail, 'blank'); return }

    if (pass.val() !== passAgain.val()) { Forms.showError([pass[0], passAgain[0]], 'equalPass'); return }
    if (pass.val().length < 6) { Forms.showError(pass, 'min'); return }
    if (pass.val().length > 12) { Forms.showError(pass, 'max'); return }
    if (pass.is(':blank')) { Forms.showError(pass, 'blank'); return }

    if (passAgain.val() !== pass.val()) { Forms.showError([pass[0], passAgain[0]], 'equalPass'); return }
    if (passAgain.val().length < 6) { Forms.showError(passAgain, 'min'); return }
    if (passAgain.val().length > 12) { Forms.showError(passAgain, 'max'); return }
    if (passAgain.is(':blank')) { Forms.showError(passAgain, 'blank'); return }

    return true;
  },

  submit: function(e) {
    e.preventDefault();

    this.form = $('.sign-up.popup form');
    if (this.validate()) {

      var data = this.form.serialize();
      var url = this.form.attr('action');

      var postData = {
        url: url,
        type: 'post',
        data: data,
        success: $.proxy(this, 'success'),
        error:''
      };

      $.ajax(postData);
    }
  },

  success: function(data) {

    if (/fail/i.test(data.state)) {
      var errors = '';
      $.each(data.errors, function(key, value) {
          errors += value + '<br/>';
      });

      this.form.find('.message').html( errors ).slideDown().fadeIn();
    }

    if (/ok/i.test(data.state)) {
      $('.sign-up.popup').fadeOut(150, $.proxy(function() {
        this.form.prev('.activation').removeClass('hidden');
        this.form.remove();
      }, this)).fadeIn(150);
      setTimeout(function() {}, 2000);
    }
  }
}

MP.SignIn = function () { this.init() }
MP.SignIn.prototype = {
  init: function() {
    this.showers = '.header .login .sign-in, .sign-in-for-ask, .post .sign-in, .wrapper .sign-in';
    this.hiders = '.popup.sign-in > a.close, .overlay';
    this.className = '.popup.sign-in';
    this.url = '/popups/signin';
    this.forgot = '.popup.sign-in .forgot';

    $('body').delegate(this.showers, 'click touchstart', $.proxy(this, 'show'));
    $('body').delegate(this.hiders, 'click touchstart', $.proxy(this, 'hide'));
    $('body').delegate(this.className, 'shown', $.proxy(this, 'shown'));
    $('body').on('input[type=submit]', $('.sign-in.popup form'), $.proxy(this, 'submit'));

    if ( $('body').data('show-popup') == 'unauthorized' ) {
      PopUp.show(this.className, '/popups/signin');
    }

    $('body').on('click', this.forgot, $('.sign-in.popup'), $.proxy(this, 'hidePartly'));
  },

  show: function(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();
    PopUp.show(this.className, this.url);
  },

  hide: function(e) {
    if (e) e.preventDefault();

    PopUp.hide(this.className);
  },

  hidePartly: function(e) {
    if (e) e.preventDefault();
    PopUp.hide(this.className, true);
  },

  shown: function() {
    this.form = $(this.className);
    this.form.unbind().bind('submit', $.proxy(this, 'submit'));
  },

  validate: function() {
    Forms.hideErrors(this.form);

    var login = this.form.find('input.login');
    var pass = this.form.find('input.password');

    if (login.is(':blank')) { Forms.showError(login, 'blank'); return };

    if (pass.val().length < 6) { Forms.showError(pass, 'min'); return };
    if (pass.val().length > 30) { Forms.showError(pass, 'max'); return };
    if (pass.is(':blank')) { Forms.showError(pass, 'blank'); return };

    return true;
  },

  submit: function(e) {
    e.preventDefault();

    this.form = $('.sign-in.popup form');

    if (this.validate()) {
      var data = this.form.serialize();
      var url = this.form.attr('action');

      var postData = {
        url: url,
        type: 'post',
        data: data,
        success: $.proxy(this, 'success'),
        error: $.proxy(this, 'error')
      };

      $.ajax(postData);
    }
  },

  success: function(data) {

    $('.sign-in.popup').fadeOut(150, $.proxy(function() {
      this.form.prev('.welcomes').removeClass('hidden').find('strong').text(data.login);
      this.form.remove();
    }, this)).fadeIn(150);
    setTimeout(function() {
      document.location.reload(true)
    }, 2000);

  },

  error: function(data) {
    this.form.find('.message').html( data.responseText ).slideDown().fadeIn();
  }
}

MP.SignInFast = function () { this.init() }
MP.SignInFast.prototype = {
  init: function() {
    this.hiders = '.popup.sign-in-fast > a.close';
    this.chooseExistedAccount = '.popup.sign-in-fast .choose-existed-account';
    this.className = '.popup.sign-in-fast';
    this.url = '/popups/sign_in_fast';

    var showPopup = $('body').data('show-popup') === 'sign_in_fast';

    if (showPopup) {
      PopUp.show(this.className, this.url);
    }

    $('body').delegate(this.hiders, 'click', $.proxy(this, 'hide'));
    $('body').delegate(this.className, 'shown', $.proxy(this, 'shown'));
    $('body').on('input[type=submit]', $('.sign-in-fast.popup form'), $.proxy(this, 'submit'));

    $('body').on('click', this.chooseExistedAccount, $('.popup.sign-in-fast'), $.proxy(this, 'hidePartly'));
  },

  show: function(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();
    PopUp.show(this.className, this.url);
  },

  hide: function(e) {
    if (e) e.preventDefault();
    if (e) e.stopImmediatePropagation();
    PopUp.hide(this.className);
  },

  hidePartly: function(e) {
    if (e) e.preventDefault();
    PopUp.hide(this.className, true);
  },

  shown: function() {
    this.form = $(this.className);
    this.form.unbind().bind('submit', $.proxy(this, 'submit'));
  },

  validate: function() {
    Forms.hideErrors(this.form);

    var login = this.form.find('input#login');
    var email = this.form.find('input#email');

    if (login.is(':blank')) { Forms.showError(login, 'blank'); return };
    if (email.is(':blank')) { Forms.showError(email, 'blank'); return };

    return true;
  },

  submit: function(e) {
    e.preventDefault();

    this.form = $('.sign-in-fast.popup form');

    if (this.validate()) {
      var data = this.form.serialize();
      var url = this.form.attr('action');

      var postData = {
        url: url,
        type: 'post',
        data: data,
        success: $.proxy(this, 'success'),
        error: $.proxy(this, 'error')
      };

      $.ajax(postData);
    }
  },

  success: function(data) {

    if (/fail/i.test(data.state)) {
      var errors = '';
      $.each(data.errors, function(key, value) {
          errors += value + '<br/>';
      });

      this.form.find('.message').html( errors ).slideDown().fadeIn();
    }

    if (/ok/i.test(data.state)) {
      $('.sign-in-fast.popup').fadeOut(150, $.proxy(function() {
        this.form.prev('.welcomes').removeClass('hidden').find('strong').text(data.login);
        this.form.remove();
      }, this)).fadeIn(150);
      setTimeout(function() {
        document.location.reload(true)
      }, 2000);
    }

  },

  error: function(data) {
    this.form.find('.message').html( data.responseText ).slideDown().fadeIn();
  }
}

MP.Forgot = function () { this.init() }
MP.Forgot.prototype = {
  init: function() {
    this.showers = '.popup.sign-in .forgot';
    this.hiders = '.popup.forgot > a.close';
    this.className = '.popup.forgot';
    this.url = '/popups/forgot.html';

    $('body').delegate(this.hiders, 'click', $.proxy(this, 'hide'));
    $('body').delegate(this.className, 'shown', $.proxy(this, 'shown'));
    $('body').on('input[type=submit]', $('.forgot.popup form'), $.proxy(this, 'submit'));

    $('body').on('click', this.showers, $('.sign-in.popup'), $.proxy(this, 'show'));
  },

  show: function(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();
    PopUp.show(this.className, this.url);
  },

  hide: function(e) {
    if (e) e.preventDefault();
    if (e) e.stopImmediatePropagation();
    PopUp.hide(this.className);
  },

  shown: function() {
    this.form = $(this.className);
    this.form.unbind().bind('submit', $.proxy(this, 'submit'));
  },

  validate: function() {
    Forms.hideErrors(this.form);

    var email = this.form.find('input#email');

    if (email.is(':blank')) { Forms.showError(email, 'blank'); return };

    return true;
  },

  submit: function(e) {
    e.preventDefault();

    this.form = $('.forgot.popup form');

    if (this.validate()) {
      var data = this.form.serialize();
      var url = this.form.attr('action');

      var postData = {
        url: url,
        type: 'post',
        data: data,
        success: $.proxy(this, 'success'),
        error:''
      };

      $.ajax(postData);
    }
  },

  success: function(data) {
    if (/fail/i.test(data.state)) {
      this.form.find('.message').html( data.errors ).slideDown().fadeIn();
    }

    if (/ok/i.test(data.state)) {
      $('.forgot.popup form').fadeOut(150, $.proxy(function() {
        this.form.prev('.sent').removeClass('hidden');
        this.form.remove();
      }, this));

      setTimeout($.proxy(function() {
        PopUp.hide(this.className);
      }, this), 1000);
    }
  }
}

MP.ChangePassword = function () { this.init() }
MP.ChangePassword.prototype = {
  init: function() {
    this.hiders = '.popup.change_password > a.close';
    this.className = '.popup.change_password';
    this.url = '/popups/change_password';

    $('body').delegate(this.hiders, 'click', $.proxy(this, 'hide'));
    $('body').delegate(this.className, 'shown', $.proxy(this, 'shown'));
    $('body').on('input[type=submit]', $('.forgot.popup form'), $.proxy(this, 'submit'));

    if ( $('body').data('show-popup') == 'change_password' ) {
      PopUp.show(this.className, this.url);
    }
  },

  hide: function(e) {
    if (e) e.preventDefault();
    if (e) e.stopImmediatePropagation();
    PopUp.hide(this.className);
  },

  shown: function() {
    this.form = $(this.className).find('form');
    this.form.unbind().bind('submit', $.proxy(this, 'submit'));
  },

  validate: function() {
    Forms.hideErrors(this.form);

    return true;
  },

  submit: function(e) {
    e.preventDefault();

    this.form = $('.change_password.popup form');

    if (this.validate()) {
      var data = this.form.serialize();
      var url = this.form.attr('action');

      var postData = {
        url: url,
        type: 'post',
        data: data,
        success: $.proxy(this, 'success'),
        error:''
      };

      $.ajax(postData);
    }
  },

  success: function(data) {
    if (/fail/i.test(data.state)) {
      this.form.find('.message').html( data.errors[0][1] ).slideDown().fadeIn();
    }

    if (/ok/i.test(data.status)) {
      $('.popup.change_password form').fadeOut(150, $.proxy(function() {
        this.form.prev('.changed').removeClass('hidden');
        this.form.remove();
      }, this));

      setTimeout($.proxy(function() {
        PopUp.hide(this.className);
        window.location = data.html;
      }, this), 1000);
    }
  }
}

MP.NewTicket = function () { this.init() }
MP.NewTicket.prototype = {
  init: function() {
    this.showers = '.team a.btn';
    this.hiders = '.popup.new-ticket > a.close';
    this.className = '.popup.new-ticket';
    this.url = '/popups/new_ticket';

    $('body').delegate(this.showers, 'click', $.proxy(this, 'show'));
    $('body').delegate(this.hiders, 'click', $.proxy(this, 'hide'));
    $('body').delegate(this.className, 'shown', $.proxy(this, 'shown'));
  },

  show: function(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();
    PopUp.show(this.className, this.url);

    if (!!this.form) {
      this.form.show().siblings('.sent').addClass('hidden');
      this.form.find(':text,textarea').val('');
    }
  },

  hide: function(e) {
    if (e) e.preventDefault();
    if (e) e.stopImmediatePropagation();
    PopUp.hide(this.className);
  },

  shown: function() {
    this.form = $(this.className);
    this.form.unbind().bind('submit', $.proxy(this, 'submit'));

    this.subject = this.form.find('input#subject');
    this.question = this.form.find('textarea#question');
    this.addFile = this.form.find('input#file');
    this.removeFile = this.form.find('.remove');

    this.addFile.unbind().on('change', this.addFileAction);
    this.removeFile.unbind().on('click', this.removeFileAction);

    Forms.toggleValue( [this.subject[0]] );
  },

  addFileAction: function() {
    var addFilesAmount = $('.attachments > ul > li').length,
        extensionFilter = /^(?:image\/bmp|image\/cis\-cod|image\/gif|image\/ief|image\/jpeg|image\/jpeg|image\/jpeg|image\/pipeg|image\/png|image\/svg\+xml|image\/tiff|image\/x\-cmu\-raster|image\/x\-cmx|image\/x\-icon|image\/x\-portable\-anymap|image\/x\-portable\-bitmap|image\/x\-portable\-graymap|image\/x\-portable\-pixmap|image\/x\-rgb|image\/x\-xbitmap|image\/x\-xpixmap|image\/x\-xwindowdump)$/i;

    var file = this.files[0];
    var reader = new FileReader();

    if (addFilesAmount >= 5) {
      alert('Многовато файлов то уже'); return
    }

    if (!extensionFilter.test(file.type)) {
      alert("Да это ж не картинка!"); return
    }

    reader.onerror = function(stuff) {
      console.log("error", stuff)
      console.log (stuff.getMessage())
    }

    reader.onload = function(e) {
      var result = e.target.result,
          url = '/upload/create_image',
          mediaFilesHolder = $('.attachments > ul'),
          mediaFilesCounter = $('.attachments > .currently');

      $.post(url, { fdata: result, fname: file.name }, function(data) {

        if (data.result == 'ok') {
          var fileName = file.name,
              url = data.url,
              id = data.id,
              template = '<li data-id="' + id +'"><div class="filename">' + fileName + '</div><a class="remove" href="#" title="Удалить"></a></li>';

          mediaFilesHolder.append( template );

          var max = 5,
              currently = mediaFilesHolder.find('> li').length,
              counterTemplate = '(' + currently + ' из ' + max + ')';
        } else {
          alert('shit!');
        }

      });
    }

    reader.readAsDataURL(file);
  },

  removeFileAction: function(e) {
    e.preventDefault();

    var target = e.target,
        li = $(target).parents('li'),
        id = li.data('id'),
        url = '/upload/destroy';

    $.post(url, { id: id }, function(data) {

      if (data.result = 'ok') {
        li.remove();

        var max = 5,
            mediaFilesHolder = $('.attachments > .media > .added'),
            mediaFilesCounter = $('.attachments > .media > .add > .currently'),
            currently = mediaFilesHolder.find('> li').length,
            counterTemplate = '(' + currently + ' из ' + max + ')';
      } else {
        alert('shit!');
      }

    });
  },

  validate: function() {
    Forms.hideErrors(this.form);

    if (this.subject.val().length < 4) { Forms.showError(this.subject, 'min'); return }
    if (this.subject.val().length > 70) { Forms.showError(this.subject, 'max'); return }
    if (this.subject.is(':blank')) { Forms.showError(this.subject, 'blank'); return }

    if (this.question.is(':blank')) { Forms.showError(this.question, 'blank'); return }

    return true;
  },

  submit: function(e) {
    e.preventDefault();

    if (this.validate()) {
      this.form = $('.new-ticket.popup form');

      var attachments = $('.attach-file > .attachments > ul > li'),
          attachmentIds = [],
          attachmentIdsHolder = $('.attach-file > #ids');

      $.each(attachments, function() {
        var id = $(this).data('id');

        attachmentIds.push(id);
      });

      attachmentIdsHolder.val( attachmentIds );

      var data = this.form.serialize();
      var url = this.form.attr('action');

      var postData = {
        url: url,
        type: 'post',
        data: data,
        success:$.proxy(this, 'success'),
        error:''
      };

      $.ajax(postData);
    }
  },

  success: function(data) {
    if (/fail/i.test(data.state)) {
      alert('fail');
    }

    if (/ok/i.test(data.state)) {
      PopUp.hide(this.className);
     }
  }
}

MP.Forms = function() { this.init() }
MP.Forms.prototype = {
  init: function() {
  },

  messages: {
    blank: 'Поле должно быть заполнено',
    required: 'Поле обязательно к заполнению',
    email: 'Введите корректный email-адрес',
    url: 'Введите корректный URL-адрес',
    date: 'Введите корректную дату',
    digits: 'В поле должны быть только числа',
    creditcard: 'Введите корректный номер кредитной карты',
    accept: 'Вы должны быть согласны в условиями пользования сервисом',
    max: 'Максимальное кол-во символов - 12',
    min: 'Минимальное кол-во символов - 6',
    range: 'Допустимый диапазон символов - 6-12',
    equalPass: 'Пароли не совпадают'
  },

  showError: function(field, error) {
    var $field = $(field);
    $field.addClass('error');
    $field.attr('title', this.messages[error]);
  },

  hideErrors: function(form) {
    form.find('.error').addBack().removeClass('error').attr('title', '');
  },

  toggleValue: function(fields) {
    $(fields).focus(function() {
      if ( this.defaultValue === this.value ) { $(this).addClass('changed'); this.value = '' }
    })
    $(fields).blur(function() {
      if ( $(this).is(':blank') ) { $(this).removeClass('changed'); this.value = this.defaultValue }
    })
  }
}

MP.ProfileEdit = function() { this.init() }
MP.ProfileEdit.prototype = {
  init: function() {
    this.form = $('.profile-edit > form');
    this.avatar = this.form.find('input:file');

    this.location = this.form.find('input#user_city');
    this.mail = this.form.find('input#user_email');
    this.pass = this.form.find('input#user_password');
    this.passAgain = this.form.find('input#user_password_confirmation');
    this.subscribe = this.form.find('input#subscribe');

    this.countryCombobox = this.form.find('select#user_country');
    this.countryCombobox.on('change', this.chooseCountry);

    this.avatar.on('change focus click', this.addAvatar);
  },

  addAvatar: function(e) {
    var fileName = this.value;
    var holder = $('.userpic > .filename');
    holder.text(fileName);
  },

  chooseCountry: function(e) {
    var selected = $(this).find('option:selected');

    $(this).siblings('.current').html( selected.text() ).addClass('changed');
  },

  validate: function() {
    Forms.hideErrors(this.form);

    if (this.location.val().length < 2) { Forms.showError(this.location, 'min'); return }
    if (this.location.val().length > 25) { Forms.showError(this.location, 'max'); return }
    if (this.location.is(':blank')) { Forms.showError(this.location, 'blank'); return }

    if (!this.mail.is(':email')) { Forms.showError(this.mail, 'email'); return }
    if (this.mail.is(':blank')) { Forms.showError(this.mail, 'blank'); return }

    if ((this.pass.is(':filled')) && (this.pass.val().length < 6)) { Forms.showError(this.pass, 'min'); return }
    if ((this.pass.is(':filled')) && (this.pass.val().length > 20)) { Forms.showError(this.pass, 'max'); return }

    if ((this.passAgain.is(':filled')) && (this.passAgain.val().length < 6)) { Forms.showError(this.passAgain, 'min'); return }
    if ((this.passAgain.is(':filled')) && (this.passAgain.val().length > 20)) { Forms.showError(this.passAgain, 'max'); return }

    if (this.pass.val() !== this.passAgain.val()) { Forms.showError([this.pass[0], this.passAgain[0]], 'equalPass'); return }

    return true;
  },

  submit: function(e) {
    e.preventDefault();
    if (this.validate()) {
      this.form.off('submit').submit();
    }
  }
}

MP.Support = function() { this.init() }
MP.Support.prototype = {
  init: function() {
    var ticketsWrapper = $('.content > .tickets');
    var tickets = $('.content > .tickets > ul > li')
    var ticketsToggler = tickets.find('.general > .title > a');

    ticketsToggler.on('click touch', function(e) {
      e.preventDefault();
      $(this).parents('li').find('.expanded').slideToggle('fast');
    })

    this.questions = $('.content ul li a.q');
    this.questions.click(function(e) {
      e.preventDefault();

      $(this).next('.a').slideToggle();
    });
  }
}

MP.Post = function() { this.init() }
MP.Post.prototype = {
  init: function() {
    this.commentsWrapper = $('.comments');
    this.commentsHolder = $('.global-comments > ul');
    this.commentsAmount = this.commentsWrapper.children('h2');
    this.comments = this.commentsWrapper.find('ul li.comment');
    this.commentMainReply = this.commentsWrapper.find('> .reply');
    this.commentMainReplyLink = this.commentsWrapper.find('> a.reply-link');
    this.commentReplies = this.comments.find('.reply');
    this.commentReplyLinks = this.comments.find('.reply-link a.reply-anchor');
    this.commentReplyForm = this.commentsWrapper.find('form.reply');
    this.commentReplyFormSubmit = this.commentReplyForm.find('input[type=submit]');
    this.commentReplyText = this.commentReplyForm.find('textarea.comment');
    this.commentVotingLinks = this.comments.find('.header > .likes a');
    this.commentRemoveLinks = this.comments.find('a.remove');

    this.lookedBox = $('.content h1 span');
    this.lookedToggler = $('.controls .looked-toggler');
    this.isLooked = this.lookedToggler.data('looked');

    this.lookedToggler.on('click touch', $.proxy(this, 'toggleLooked'));

    this.ratingWrapper = $('.vote');
    this.ratingPoints = this.ratingWrapper.data('post-vote');
    this.ratingPostId = this.ratingWrapper.data('post-id');
    this.ratingUserId = this.ratingWrapper.data('user-id');
    this.ratingStars = this.ratingWrapper.find('.stars a');

    this.ratingStars.on('click touch', $.proxy(this, 'postVote'));
    this.commentMainReplyLink.on('click touch', $.proxy(this, 'toggleMainReplyForm'));
    this.commentReplyLinks.on('click touch', $.proxy(this, 'toggleShortReplyForm'));
    this.commentReplyFormSubmit.on('click touch', $.proxy(this, 'submit'));
    this.commentVotingLinks.on('click touch', $.proxy(this, 'commentVote'));
    this.commentRemoveLinks.on('click touch', $.proxy(this, 'removeComment'));

    $('body').on('focus', 'textarea', function() {
      $(this).autogrow();
    })
  },

  toggleLooked: function(e) {
    e.preventDefault();

    var url = $(e.target).attr('href'),
        self = this;

    $.ajax({ url: url, type: 'PUT', success: function(res) {
      if (/ok/i.test(res.state)) {
        var text = res.looked ? 'Отметить как не просмотренное' : 'Отметить как просмотренное';

        self.lookedBox.toggleClass('viewed', res.looked);
        self.lookedToggler.html(text);
      } else {
        alert('Что-то пошло не так. Попробуйте еще раз.');
      }
    }});
  },

  add: function(data) {

    if (data.state == 'Fail') {
      alert(data.errors[0][1]);
    }

    if (data.state == 'Ok') {
      var newComment = $(data.html).appendTo( this.holder );
      if (this.holder != this.commentsHolder) {
        newComment.wrap('<ul/>');
        this.holder.find( '.reply' ).hide();
        this.holder.find( '.reply-link a' ).removeClass('hidden');
      }
      this.commentReplies.find('textarea').val('');
      this.commentMainReply.find('textarea').val('');
      var top = newComment.offset().top - 20;
      $('html, body').animate({scrollTop: top}, 500);
      this.commentMainReply.empty();
    }
  },

  error: function(data) {
    alert('error');
  },

  toggleMainReplyForm: function(e) {
    e.preventDefault();

    this.commentReplies.hide();
    this.commentMainReplyLink.addClass('hidden');
    this.commentMainReply.removeClass('hidden');
    this.commentReplyLinks.removeClass('hidden');
  },

  toggleShortReplyForm: function(e) {
    e.preventDefault();

    $('.global-comments ul li.comment .reply').hide();
    $('.global-comments ul li.comment .reply-link a').removeClass('hidden');
    $(e.target).addClass('hidden').parent().next('.reply').show();
    this.commentMainReplyLink.removeClass('hidden');
    this.commentMainReply.addClass('hidden');
  },

  validateReplyText: function(replyForm, replyText) {
    Forms.hideErrors(replyForm);

    if (replyText.val().length < 6) { Forms.showError(replyText, 'min'); return }
    if (replyText.val().length > 10000) { Forms.showError(replyText, 'max'); return }
    if (replyText.is(':blank')) { Forms.showError(replyText, 'blank'); return }

    return true;
  },

  submit: function(e) {
    e.preventDefault();

    var form = $(e.target).parents('form');
    var text = form.find('textarea');

    this.holder = form.closest('li.comment').length ? form.closest('li.comment') : this.commentsHolder;

    if (this.validateReplyText(form, text)) {

      var data = form.serialize()
      var url = form.attr('action');
      var postData = {
        url: url,
        type: 'post',
        data: data,
        success: $.proxy(this, 'add'),
        error: $.proxy(this, 'error')
      };

      $.ajax(postData);
    }
  },

  removeComment: function(e) {
    e.preventDefault();

    var target = e.target,
        li = $(target).closest('li.comment'),
        id = $(target).data('id'),
        url = '/comments/destroy';

    $.post(url, { id: id }, function(data) {

      if (/ok/i.test(data.state)) {
        if (/destroy/i.test(data.action)) {
          li.remove();
        } else if (/replace/i.test(data.action)) {
          li.replaceWith( data.html )
        }
      } else if (/fail/i.test(data.state)) {
        alert(data.errors);
      } else {
        alert('try again');
      }
    });

  },

  postVote: function(e) {
    if (this.ratingWrapper.hasClass('voted')) return false;
    if (this.ratingWrapper.hasClass('author')) return false;

    var self = this,
        stars = this.ratingWrapper.find('.stars li'),
        targetStar = $(e.target).parent(),
        starIndex = (stars.index(targetStar) - 5) * -1,
        data = { 'vote': { 'value': starIndex, 'post_id': this.ratingPostId}};
    if (typeof this.ratingUserId != 'undefined') {
      data.vote.user_id = this.ratingUserId;
    }
    $.post( "/posts/vote", data, function(res) {
      if (/ok/i.test(res.state)) {
        stars.children('a').removeAttr('class')
                           .slice(-starIndex)
                           .addClass('painted');

        self.ratingWrapper.addClass('voted');
        var votes = $('.votes'),
            span_votes = $('span.rating');

        votes.html(res.post_rating);
        span_votes.html(res.post_rating);
        if (!/active/.test(votes.prop('class'))){
          span_votes.addClass('active');
          votes.addClass('active');
        }
      }
    });
  },

  postVoteSuccess: function(data) {
    if (data.state == 'fail') {
      alert(data.errors);
    }

    if (data.state == 'ok') {
      this.postVotingLinks.removeClass('voted');
      this.postVotingLink.addClass('voted');
      this.postVotingValue.text(data.votes);
      this.postVotingValue.removeClass('green red');
      if (parseInt(data.votes) > 0) {
        this.postVotingValue.addClass('green');
      } else {
        this.postVotingValue.addClass('red');
      }
    }
  },

  postVoteError: function() {},

  commentVote: function(e) {
    e.preventDefault();

    var link = $(e.target);
    var action = link.attr('class');
    var form = link.closest('form');
    var url = form.attr('action');
    var data = form.serialize();

    this.commentVotingLinks = form.parent().find('a');
    this.commentVotingLink = link;
    this.commentVotingValue = form.parent().find('span.current');

    var postData = {
      url: url,
      type: 'post',
      data: data,
      success: $.proxy(this, 'commentVoteSuccess'),
      error: $.proxy(this, 'commentVoteError')
    };

    $.ajax(postData);
  },

  commentVoteSuccess: function(data) {

    if (data.state == 'fail') {
      alert(data.errors);
    }

    if (data.state == 'ok') {
      this.commentVotingLinks.removeClass('voted');
      this.commentVotingLink.addClass('voted');
      this.commentVotingValue.text(data.votes);
      this.commentVotingValue.removeClass('green red');
      if (parseInt(data.votes) > 0) {
        this.commentVotingValue.addClass('green');
      } else {
        this.commentVotingValue.addClass('red');
      }
    }
  },

  commentVoteError: function() {
    alert('Error');
  }
}

MP.Pokerroom = function() { this.init() }
MP.Pokerroom.prototype = {
  init: function() {
    this.commentsWrapper = $('.comments');
    this.commentsHolder = $('.comments > ul.list');
    this.commentsAmount = this.commentsWrapper.children('h2');
    this.comments = this.commentsWrapper.find('ul.list');
    this.commentMainReply = this.commentsWrapper.find('> .reply');
    this.commentMainReplyLink = this.commentsWrapper.find('> a.reply-link');
    this.commentReplies = this.comments.find('.reply');
    this.commentReplyLinks = this.comments.find('.reply-link a.reply-anchor');
    this.commentReplyForm = this.commentsWrapper.find('.reply form');
    this.commentReplyFormSubmit = this.commentReplyForm.find('input[type=submit]');
    this.commentReplyText = this.commentReplyForm.find('textarea#comment');
    this.commentVotingLinks = this.comments.find('.header > .likes a');
    this.commentRemoveLinks = this.comments.find('a.remove');

    this.ratingWrapper = $('.pokerroom section.rating > .vote');
    this.ratingPoints = this.ratingWrapper.data('pokerroom-vote');
    this.ratingPokerroomId = this.ratingWrapper.data('pokerroom-id');
    this.ratingUserId = this.ratingWrapper.data('user-id');
    this.ratingStars = this.ratingWrapper.find('.stars a');

    this.postVoting = $('.content > .votes');
    this.postVotingLinks = this.postVoting.find('a');
    this.postVotingValue = this.postVoting.find('.current');

    this.ratingStars.on('click', $.proxy(this, 'pokerroomVote'));

    $('body').on('focus', 'textarea', function() {
      $(this).autogrow();
    })
  },

  pokerroomVote: function(e) {
    e.preventDefault();

    if (this.ratingWrapper.hasClass('voted')) return false;

    var self = this,
        stars = this.ratingWrapper.find('.stars li'),
        targetStar = $(e.target).parent(),
        starIndex = (stars.index(targetStar) - 5) * -1,
        data = { 'vote': { 'value': starIndex, 'pokerroom_id': this.ratingPokerroomId}};

    if (typeof this.ratingUserId != 'undefined') {
      data.vote.user_id = this.ratingUserId;
    }

    $.post( "/pokerrooms/vote", data, function(res) {
      if (/ok/i.test(res.state)) {
        stars.slice(-starIndex).find('a').attr('class', '').addClass('painted');

        self.ratingWrapper.addClass('voted');

        $('.pokerroom_rating').html(res.pokerroom_rating);
        $('.pokerroom_votes').html(res.pokerroom_count_vote);
        $('.current .votes').html(res.pokerroom_rating);
      }
    });
  },

  add: function(data) {
    if (data.state == 'Fail') {
      alert(data.errors[0][1]);
    }

    if (data.state == 'Ok') {
      var newComment = $(data.html).appendTo( this.holder );
      if (this.holder != this.commentsHolder) {
        newComment.wrap('<ul/>');
        this.holder.find( '.reply' ).hide();
        this.holder.find( '.reply-link a' ).removeClass('hidden');
      }
      this.commentReplies.find('textarea').val('');
      this.commentMainReply.find('textarea').val('');
      var top = newComment.offset().top - 20;
      $('html, body').animate({scrollTop: top}, 500);
    }
  },

  error: function(data) {
    alert('error');
  },

  toggleMainReplyForm: function(e) {
    e.preventDefault();

    this.commentReplies.hide();
    this.commentMainReplyLink.addClass('hidden');
    this.commentMainReply.removeClass('hidden');
    this.commentReplyLinks.removeClass('hidden');
  },

  toggleShortReplyForm: function(e) {
    e.preventDefault();

    $('.global-comments ul li.comment .reply').hide();
    $('.global-comments ul li.comment .reply-link a').removeClass('hidden');
    $(e.target).addClass('hidden').parent().next('.reply').show();
    this.commentMainReplyLink.removeClass('hidden');
    this.commentMainReply.addClass('hidden');
  },

  validateReplyText: function(replyForm, replyText) {
    Forms.hideErrors(replyForm);

    if (replyText.val().length < 6) { Forms.showError(replyText, 'min'); return }
    if (replyText.val().length > 10000) { Forms.showError(replyText, 'max'); return }
    if (replyText.is(':blank')) { Forms.showError(replyText, 'blank'); return }

    return true;
  },

  submit: function(e) {
    e.preventDefault();

    var form = $(e.target).parent('form');
    var text = form.find('textarea#comment');

    this.holder = form.closest('li.comment').length ? form.closest('li.comment') : this.commentsHolder;

    if (this.validateReplyText(form, text)) {

      var data = form.serialize()
      var url = form.attr('action');
      var postData = {
        url: url,
        type: 'post',
        data: data,
        success: $.proxy(this, 'add'),
        error: $.proxy(this, 'error')
      };

      $.ajax(postData);
    }
  },

  removeComment: function(e) {
    e.preventDefault();

    var target = e.target,
        li = $(target).closest('li.comment'),
        id = $(target).data('id'),
        url = '/comments/destroy';

    $.post(url, { id: id }, function(data) {

      if (/ok/i.test(data.state)) {
        if (/destroy/i.test(data.action)) {
          li.remove();
        } else if (/replace/i.test(data.action)) {
          li.replaceWith( data.html )
        }
      } else if (/fail/i.test(data.state)) {
        alert(data.errors);
      } else {
        alert('try again');
      }
    });

  },

  postVote: function(e) {
    e.preventDefault();

    var link = $(e.target).closest('a');
    var action = link.attr('class');
    var form = link.closest('form');
    var url = form.attr('action');
    var data = form.serialize();
    this.postVotingLink = link;
    var postData = {
      url: url,
      type: 'post',
      data: data,
      success: $.proxy(this, 'postVoteSuccess'),
      error: $.proxy(this, 'postVoteError')
    };

    $.ajax(postData);
  },

  postVoteSuccess: function(data) {
    if (data.state == 'fail') {
      alert(data.errors);
    }

    if (data.state == 'ok') {
      this.postVotingLinks.removeClass('voted');
      this.postVotingLink.addClass('voted');
      this.postVotingValue.text(data.votes);
      this.postVotingValue.removeClass('green red');
      if (parseInt(data.votes) > 0) {
        this.postVotingValue.addClass('green');
      } else {
        this.postVotingValue.addClass('red');
      }
    }
  },

  postVoteError: function() {},

  commentVote: function(e) {
    e.preventDefault();

    var link = $(e.target);
    var action = link.attr('class');
    var form = link.closest('form');
    var url = form.attr('action');
    var data = form.serialize();

    this.commentVotingLinks = form.parent().find('a');
    this.commentVotingLink = link;
    this.commentVotingValue = form.parent().find('span.current');

    var postData = {
      url: url,
      type: 'post',
      data: data,
      success: $.proxy(this, 'commentVoteSuccess'),
      error: $.proxy(this, 'commentVoteError')
    };

    $.ajax(postData);
  },

  commentVoteSuccess: function(data) {

    if (data.state == 'fail') {
      alert(data.errors);
    }

    if (data.state == 'ok') {
      this.commentVotingLinks.removeClass('voted');
      this.commentVotingLink.addClass('voted');
      this.commentVotingValue.text(data.votes);
      this.commentVotingValue.removeClass('green red');
      if (parseInt(data.votes) > 0) {
        this.commentVotingValue.addClass('green');
      } else {
        this.commentVotingValue.addClass('red');
      }
    }
  },

  commentVoteError: function() {
    alert('Error');
  }
}

MP.Banner = function(){ this.init() }
MP.Banner.prototype = {
  init: function(){
    this.banner_field = $('.banner > .wrapper');
    this.animated_banner_class = 'EDGE-1327498';
    this.animated_banner_field = $('.banner > .wrapper > .' + this.animated_banner_class);

    this.banner_field.ready($.proxy(this, 'rotatingBanner'));
  },
  rotatingBanner: function(){
    var
      field = this.banner_field,
      gallery = $('.page > .banner');

    field.load('/rotating_banner', function(){
      var
        slides = gallery.find('a'),
        interval = 5000,
        speed = 500,
        activeSlide, nextSlide;

      $(sample(slides)).addClass('active');

      function sample(values){
        return values[Math.floor(Math.random() * values.length)];
      }

      if (!gallery.length || slides.length < 2) return;

      setInterval(function() {
        activeSlide = slides.filter('.active');
        nextSlide = activeSlide.next().length ? activeSlide.next() : slides.first();

        activeSlide.fadeOut(speed, function() {
          $(this).removeClass('active');

          nextSlide.addClass('active').hide().fadeIn(speed);
        });
      }, interval)
    });
  },
  animatedBanner: function(){
    AdobeEdge.loadComposition('/banner', this.animated_banner_class, {
      scaleToFit: "none",
      centerStage: "none",
      minW: "0px",
      maxW: "undefined",
      width: "1073px",
      height: "163px"
    }, {"dom":{}}, {"dom":{}});
    this.animated_banner_field.on('click', function(){
       window.location = 'https://ru.mirpokera.com/bezdepozitnyy-bonus-200-v-lotos-poker';
    });
  }
}

/* Left sticky navigation */

MP.NavigationMenu = function() { this.init() }
MP.NavigationMenu.prototype = {
  init: function(){
    this.nav_menu = $('.sticky-nav');
    this.nav_menu.ready($.proxy(this, 'show'));
  },

  show: function(){
    var nav = this.nav_menu,
        toggler = nav.find('.toggler'),
        list = nav.find('.list'),
        navWidth = 200,
        shouldShow, direction, speed, isHided, windowWidth, scrolledY, action;

    toggler.on('click', function(e) {
      e.preventDefault();

      var max_show = nav.hasClass('max_show');
      var small_show = nav.hasClass('small_show');

      if (!max_show && !small_show) {
        if (window.window.innerWidth > 1024 && window.innerWidth < 1536) {
          action = nav.hasClass('hided') ? 'small_show' : 'small_hide'
        } else {
          action = nav.hasClass('hided') ? 'show' : 'hide';
        }
      } else {
        if(max_show) action = nav.hasClass('hided') ? 'show' : 'hide';
        if(small_show) action = nav.hasClass('hided') ? 'small_show' : 'small_hide'
      }

      nav.trigger(action);
    });

    nav.on('small_show small_hide', function(e) {
      shouldShow = e.type == 'small_show';
      windowWidth = $(window).width();
      speed = 200;
      direction = shouldShow ? '=0' : '=0';

      if (shouldShow) list.show();
      if (!shouldShow) {
        nav.addClass('hided');

        nav.addClass('small_hided');
        nav.removeClass('small_show');
      }

      nav.animate({'marginLeft': direction}, speed, function() {
        if (shouldShow) {
          nav.removeClass('hided');

          nav.removeClass('small_hided');
          nav.addClass('small_show');
        }
        if (!shouldShow) list.fadeOut(200);
      });
    });

    nav.on('show hide quickHide', function(e) {
      shouldShow = e.type == 'show';
      windowWidth = $(window).width();
      speed = 200;

      direction = shouldShow ? '-=200' : '+=200';

      if (e.type == 'quickHide') { speed = 0; }

      if (shouldShow) list.show();
      if (!shouldShow) {
        nav.addClass('hided');

        nav.addClass('max_hided');
        nav.removeClass('max_show');
      }

      nav.animate({'marginLeft': direction}, speed, function() {
        if (shouldShow) {
          nav.removeClass('hided');

          nav.removeClass('max_hided');
          nav.addClass('max_show');
        }
        if (!shouldShow) list.fadeOut(200);
      });

      if (e.type == 'quickHide') return;

      if (windowWidth < 1500) {
        var indent = 225 - ((windowWidth - 1074) / 2),
        indent = shouldShow ? indent : -indent;

        if (shouldShow) $('body').addClass('scrolless');

        $('body').animate({'left': '+=' + indent}, speed, function() {
          if (!shouldShow) $(this).removeClass('scrolless');
        })
      }
    });

    $(window).on('resize load', function(e) {});

    $(document).mouseup(function(e) {
      if (nav.hasClass('hided')) return;

      if (!nav.is(e.target) && nav.has(e.target).length === 0) {
        var max_show = nav.hasClass('max_show');
        var small_show = nav.hasClass('small_show');

        if (!max_show && !small_show) {
          if (window.window.innerWidth > 1024 && window.innerWidth < 1536) {
            action = nav.hasClass('hided') ? 'small_show' : 'small_hide'
          } else {
            action = nav.hasClass('hided') ? 'show' : 'hide';
          }
        } else {
          if(max_show) action = nav.hasClass('hided') ? 'show' : 'hide';
          if(small_show) action = nav.hasClass('hided') ? 'small_show' : 'small_hide'
        }

        nav.trigger(action);
      }
    });
  }
}

/* Search */

MP.Search = function() { this.init() }
MP.Search.prototype = {
  init: function() {
    this.search_field = $('header .search .toggler');

    this.search_field.ready($.proxy(this, 'show_input'));
  },

  show_input: function() {
    var toggler = this.search_field,
        field = $('.popup.suggest .field input');

    toggler.on('click', function(e) {
      e.preventDefault();

      $('.popup.suggest').fadeTo(400, 1);
    });

    $('.popup.suggest .close').on('click', function() {
      $('.popup.suggest').fadeOut();
      $('.popup.suggest .results').html('');
      $('.popup.suggest .field input').val('')
    })

    field.on('keyup', function(e) {
      var value = $(this).val(),
          object = '.popup.suggest';

      if (value.length > 2) {
        var url = "/elastic_search";
        $.ajax({
          type: 'GET',
          url: url,
          data: {q: field.val()},
          success: function(data) {
            $('.popup.suggest .results').html(data);
          }
        });

      }
    });

    field.keydown( function( event ) {
      if ( event.which === 13 ) {
          event.preventDefault();
          return false;
      }
  });
  }
}

/* Appending media quieries depend on screen size */

function tablet() {
  var isTablet = window.matchMedia("only screen and (max-device-width: 1024px), (max-width: 1024px)");
  var isMobile = window.matchMedia("only screen and (max-device-width: 760px), (max-width: 760px)");
  var isPortrait = window.matchMedia('only screen and (orientation: portrait)');

  if (isTablet.matches || isMobile.matches) {
    var step2 = $('.how-to-play .step2'),
        step3 = $('.how-to-play .step3');

    if ( isPortrait.matches ) {
      step2.after(step3);
    } else {
      step3.after(step2);
    }


  }
  if (isMobile.matches) {
    var play = $('.pokerroom .info .play'),
        bonus = $('.pokerroom .info .bonus');

    play.after(bonus);
  }
}

$(function() {

  /* flowplayer */

  if ($('a.player').length) flowplayer("a.player", "https://ru.mirpokera.com/assets/flowplayer.commercial-3.2.16.swf", {
    key: '#$2e9a150b0c04b7002f1',
    logo: {
      url: '/assets/img/logo-for-video.png',
      fullscreenOnly: true,
      displayTime: 0,
      linkUrl: 'https://ru.mirpokera.com'
    }
  });

  mobileNav();
  videoFilter();
  blogsToggler();
  stickyPanelOnPokerrooms();
  tablet();
  lightbox();

  window.addEventListener("orientationchange", function() {
    tablet();
  });


  /* Global */

  window.GlobalProperties = new MP.GlobalProperties();
  window.GlobalHandler = new MP.GlobalHandler();

  /* DropDowns */

  window.DropDowns = new MP.DropDowns();


  /* Comboboxes */

  window.Combobox = new MP.Combobox();


  /* PopUps */

  window.PopUp = new MP.PopUp();

  window.SignUp = new MP.SignUp();
  window.SignIn = new MP.SignIn();
  window.SignInFast = new MP.SignInFast();
  window.Forgot = new MP.Forgot();
  window.ChangePassword = new MP.ChangePassword();
  window.NewTicket = new MP.NewTicket();


  /* Forms */

  window.Forms = new MP.Forms();


  /* Navigation Menu */

  window.NavigationMenu = new MP.NavigationMenu();

  /* ElasticSearch */

  window.Search = new MP.Search();

  /* Depend on page */

  var page = GlobalProperties.Page;

  if (/profile-edit/.test(page)) {
    window.ProfileEdit = new MP.ProfileEdit();
  }

  if (/pokerroom/.test(page)) {
    window.Pokerroom = new MP.Pokerroom();
  }

  if (/support/.test(page)) {
    window.Support = new MP.Support();
  }

  if (/post/.test(page)) {
    window.Comments = new MP.Post();
  }

  if (/main/.test(page) || /post/.test(page) || /video/.test(page) || /frontpage/.test(page)) {
    $(window).on('load', function(){ window.Banner = new MP.Banner() });
  }

  NewPost();
  WYSIWG();
});

window.clear_from_reply = function() {
  $('.reply').find('textarea#comment').val('');
}

window.click_reply = function() {
  $('a.reply').on('click', function(e) {
    var event = jQuery.Event("keydown", { keyCode: 27 });
    jQuery(".reply").trigger( event );
    var _this = e.target;
    if(jQuery.inArray("delete", _this.classList) >= 0){
      $.ajax({
        url: "/comments/destroy?id=" + _this.id,
        type: 'POST',
        success: function(data) {
          $('.comments .list').load('comments/list_comments?id=' + data.owner_id + '&model=' + data.type, function(){
            change_comments_count(data.count, true);
          });
        }
      });
    }
    else{
      $.ajax({
        url: "comments/reply_comments?comment_id=" + _this.id,
        success: function(data) {
          $(_this).after(data)
          $(_this).css('display', 'none');
          $('.reply').keydown(function (e)
          {
              if (e.keyCode == 27) {
                  $('.box form.reply').remove();
                  $("a.reply").css('display', 'block');
              }
          });
        }
      });
    }
  });
}

window.authors_comments = function() {
  var list = $(".comments .list"),
      comments = list.children(".comments"),
      info = comments.find(".info"),
      authors = list.children(".authors"),
      author = authors.children(".author");
  authors.css("display", "none");
  $('.options-list .authors').on( 'click', function(){
    params('none', 'none', 'block')
    return false;
  });
  $('.authors .author, .options-list .comments').on( 'click', function(e){
    var target = $(e.target),
        user_id = target.attr('id');
    params('block', 'block', 'none')
    if (/info/.test(target.attr('class'))){
      $("." + user_id).css("font-weight", "600");
    }
    return false;
  });
  function params(reply_display, commetns_display, authors_display){
    $('form.reply').css("display", reply_display);
    info.css("font-weight", "300");
    comments.css("display", commetns_display);
    authors.css("display", authors_display);
  };
}

function mobileNav() {
  var toggler = $('.mobile-nav-toggler'),
      page = $('body.page');

  $('header, .banner, .main, .sharing, footer').on('click', function(e){
    var isToggler = $(e.target).hasClass('mobile-nav-toggler');

    if (page.hasClass('mobile-nav-active') && !isToggler) {
      toggler.click();
    }
  });

  toggler.on('click', function(e) {
    e.preventDefault();

    var toggle_fixed = true;

    if (page.hasClass('fixed') && page.hasClass('mobile-nav-active')) {

      window.setTimeout(function(){
        page.removeClass('fixed')
        toggle_fixed = false;
      }, 500);
    }

    if (toggle_fixed)
      page.addClass('fixed');
    page.toggleClass('mobile-nav-active');
  })

  $('.sticky-nav .user .sign-in-toggler').on('click touchstart', function(e) {
    e.preventDefault();

    toggler.click();
    $('header .auth .sign-in .popup-toggler').click();
  })

  $('.sticky-nav .user .sign-up-toggler').on('click touchstart', function(e) {
    e.preventDefault();

    toggler.click();
    $('header .auth .sign-up .popup-toggler').click();
  })
}

function videoFilter() {
  var form = $('.page.videos form.videos-filter'),
      toggler = $('.page.videos .filter-toggler'),
      filter = $('.page.videos .videos-filter > .filter'),
      comboboxes = $('.page.videos .videos-filter .combobox'),
      url = form.attr('action'),
      categories = form.find('.categories');

  toggler.on('click', function(e) {
    e.preventDefault();

    filter.slideToggle(300).parent().toggleClass('collapsed');

    $(this).toggleClass('collapsed');
  })

  comboboxes.on('change', function() {
    var selected = $(this).find('option:selected');

    $(this).find('.current').html( selected.text() ).addClass('changed');
  })

  form.on('submit', function() {
    var videoTypeID = categories.find('a.active').data('video-type-id'),

        params = form.serialize() + '&video_type_id=' + videoTypeID;
    console.log(params);
    $.ajax({
      type: 'GET',
      dataType: 'script',
      url: url,
      data: params,
    });

    return false;
  })

  categories.find('a').on('click', function(e) {
    e.preventDefault();

    categories.find('a').removeClass('active');
    $(e.target).addClass('active');

    form.submit();
  })
}

function blogsToggler() {
  var isBlogs = $('.page').hasClass('blogs'),
      listDefault = $('.blogs-list'),
      lists = {
        'pokerrooms': $('<ul class="blogs-list pokerrooms"/>').insertAfter(listDefault),
        'other': $('<ul class="blogs-list other"/>').insertAfter(listDefault),
      },
      togglers = $('.blogs-list a.blog').filter('.pokerrooms, .other'),
      toggler,
      opts,
      elem,
      target,
      title;

  if (isBlogs) {
    togglers.on('click', function(e) {
      e.preventDefault();

      elem = $(e.target).hasClass('a.blog') ? $(e.target) : $(e.target).closest('a.blog'),
      target = elem.attr('rel'),
      title = elem.find('.title').text(),
      opts = { folder: target };

      if (listDefault.siblings('.' + target).children().length > 0) {
        listDefault.hide().siblings('.' + target).show();
        return;
      }

      $.get('/ratings/find_blogs_in_folder', opts, function(res) {
        if ( !$('.content > .back').length ) {
          $('.content > .intro').after('<a class="back" href="#" style="display:block; float:right; padding:0 15px; height:21px; margin:5px 25px 0 0; background:#a9a9a9; font:12px/21px \'Roboto\',Arial,serif; color:#fff; text-decoration:none; border-radius:10px">назад</a>');
        }

        listDefault.hide();
        lists['pokerrooms'].hide();
        lists['other'].hide();
        lists[target].html(res).show();

        $('html, body').animate({ scrollTop: $(".content").offset().top-30 }, 500);

        $('.content > .back').on('click', function(e) {
          e.preventDefault();

          listDefault.siblings('ul').hide().end().show();
        })
      })
    })
  }
}

function stickyPanelOnPokerrooms() {
  var block = $('.sticky-panel'),
      show;

  $(document).on('scroll', function() {
    show = $(document).scrollTop() >= 800 ? 1 : 0;

    if (show) {
      block.fadeIn( 500 );
    } else {
      block.fadeOut( 500 );
    }
  });
}

function lightbox() {
  var anchors = $('a.lightbox'),
      lightboxPopup = $('.lightbox-popup'),
      overlay = $('.overlay');

  anchors.on('click', function(e) {
    e.preventDefault();
    var url = $(this).attr('rel');

    lightboxPopup.fadeIn(300).html('<img src="' + url + '"/>');
  })

  lightboxPopup.on('click', function(e) {
    e.preventDefault();

    lightboxPopup.fadeOut(300);
  });
}

window.change_comments_count = function(comments_count, destroy) {
  $.each($('a.comments'), function( index, value ) {
    if ( destroy == true)
      value.text = value.text.replace(comments_count + 1, comments_count);
    else
      value.text = value.text.replace(comments_count - 1, comments_count);
  });
}

function NewPost() {
  $('.upload').change(function() {
    var filename = $(this).val().split('\\').pop();

    $('.filename').html(filename)
  })

  $('#new_post #title, #new_post #slug_cache').on('blur', function(e) {
    var value = $(e.target).val();

    if (!value.length) return;

    var data = { "slug_cache": value };

    $.get('/posts/verify_slug_cache', data, function(res) {
      if (/ok/.test(res.status)) {
        $('#new_post #slug_cache').val( res.slug_cache ).removeClass('error');
      } else {
        $('#new_post #slug_cache').val( '' ).parent().addClass('error');
        alert('Пост с таким url уже существует');
      }
    });
  });

  // TODO: Rework date picker
  if ( $('.deffering.field').length ) {
    $( "#datepicker" ).datepicker({
      dateFormat: "dd.mm.yy",
      minDate: 0,
      onSelect: function(date) {
        $('.publish-date .date').html(date);
      }
    });

    $('#datepicker').datepicker("setDate", new Date());

    $('.ui-datepicker-current-day a').click();

    $('.choose-date').on('click', function(e) {
      e.preventDefault();
      $( "#datepicker" ).datepicker("show");
    });

    $('.combobox.hours select, .combobox.minutes select').change(function() {
      $('.publish-date .time').html( $('.combobox.hours select option:selected').text() + ':' + $('.combobox.minutes select option:selected').text() );
    });
  }

  $('#new_post').on('submit', function() {
    var errors = false;

    $('#title, #slug_cache, #upload, #excerpt, #postContent, #meta_title, #meta_desc, #meta_keywords').parents().removeClass('error');

    var title = $('#title');
    if ((title.val().length < 6) || (title.val().length > 100)) { title.siblings('.message').html('Длина заголовка должна быть в диапазоне 6-100 символов').parent().addClass('error'); errors = true; }

    var slug = $('#slug_cache');
    if ((slug.val().length < 6) || (slug.val().length > 100)) { slug.siblings('.message').html('Длина ссылки должна быть в диапазоне 6-100 символов').parent().addClass('error'); errors = true; }

    var excerpt = $('#excerpt');
    if ((excerpt.val().length < 10) || (excerpt.val().length > 800)) { excerpt.siblings('.message').html('Длина описания должна быть в диапазоне 10-800 символов').parent().addClass('error'); errors = true; }

    var file = $('#upload');
    if (file.get(0).files.length === 0) { file.siblings('.message').html('Необходимо добавить превью').parent().addClass('error'); errors = true; }

    var postContent = $('#postContent');
    if ((postContent.val().length < 6) || (postContent.val().length > 100000)) { postContent.closest('.html').siblings('.message').html('Длина поста должна быть в диапазоне 6-100000 символов').parent().parent().addClass('error'); errors = true; }

    var meta_title = $('#meta_title');
    if ((meta_title.val().length < 10) || (meta_title.val().length > 800)) { meta_title.siblings('.message').html('Длина тайтла должна быть в диапазоне 10-800 символов').parent().addClass('error'); errors = true; }

    var meta_desc = $('#meta_desc');
    if ((meta_desc.val().length < 10) || (meta_desc.val().length > 800)) { meta_desc.siblings('.message').html('Длина description должна быть в диапазоне 10-800 символов').parent().addClass('error'); errors = true; }

    var meta_keywords = $('#meta_keywords');
    if ((meta_keywords.val().length < 10) || (meta_keywords.val().length > 800)) { meta_keywords.siblings('.message').html('Длина keywords должна быть в диапазоне 10-800 символов').parent().addClass('error'); errors = true; }

    return !errors;
  })
}

function WYSIWG() {
  $('textarea#postContent').markItUp(markItUpConfig).focus();

  // popup 'Big cards' - toggle popup
  $('.markItUpButton20 a, .wysiwyg-popup.cards-big .add a, .wysiwyg-popup.cards-big .close').on('click', function(e) {
    e.preventDefault();

    if ($(e.target).parents('.markItUpButton20').length) {
      $('.wysiwyg-popup.cards-big input').val(''); // erase data before open popup
    }

    $('.wysiwyg-popup.cards-big').fadeToggle(200);
  })

  // popup 'Big cards' - add card to editor
  $('.wysiwyg-popup.cards-big .add a').on('click', function(e) {
    e.preventDefault();

    var title = $('.wysiwyg-popup.cards-big .cards_title input').val(),
        cards = $('.wysiwyg-popup.cards-big .list input'),
        card1 = cards.eq(0).val(),
        card2 = cards.eq(1).val(),
        card3 = cards.eq(2).val(),
        card4 = cards.eq(3).val(),
        card5 = cards.eq(4).val(),
        code = '<div class="cards"><span class="title">' + title + '</span><ul class="cards-list">';

    $.each(cards, function(i,v) {
      if (cards.eq(i).val().length) {
        code += '<li class="poker-card c-' + cards.eq(i).val() + '"></li>'
      }
    })

    code += '</ul></div>'

    $.markItUp({ name:"Image", replaceWith:code });
  });

  // popup 'Small cards' - toggle popup
  $('.markItUpButton21 a, .wysiwyg-popup.cards-small .add a, .wysiwyg-popup.cards-small .close').on('click', function(e) {
    e.preventDefault();

    if ($(e.target).parents('.markItUpButton21').length) {
      $('.wysiwyg-popup.cards-small input').val(''); // erase data before open popup
    }

    $('.wysiwyg-popup.cards-small').fadeToggle(200);
  })

  // popup 'Small cards' - add card to editor
  $('.wysiwyg-popup.cards-small .add a').on('click', function(e) {
    e.preventDefault();

    var cards = $('.wysiwyg-popup.cards-small input'),
        card1 = cards.eq(0).val(),
        card2 = cards.eq(1).val(),
        card3 = cards.eq(2).val(),
        card4 = cards.eq(3).val(),
        card5 = cards.eq(4).val(),
        code = '', type = ''

    $.each(cards, function(i,v) {
      if (cards.eq(i).val().length) {
        if (/d/i.test(cards.eq(i).val())) type = 'diamonds';
        if (/c/i.test(cards.eq(i).val())) type = 'clubs';
        if (/h/i.test(cards.eq(i).val())) type = 'hearts';
        if (/s/i.test(cards.eq(i).val())) type = 'spades';

        code += '<span class="card-small ' + type + '">' + cards.eq(i).val()[0] + '</span>'
      }
    })

    $.markItUp({ name:"Image", replaceWith:code });
  });

  // popups 'Insert picture' - toggle popup
  $('.markItUpButton13,.markItUpButton14,.markItUpButton15').on('click', function(e) {
    e.preventDefault();

    // erase data before open popup
    $('.wysiwyg-popup.picture input, .wysiwyg-popup.picture textarea').val('');
    if ($('.wysiwyg-popup.picture .filename').length) {
      $('.wysiwyg-popup.picture .filename').html('');
    }

    var target = e.target.tagName.toLowerCase() == 'li' ? $(e.target) : $(e.target).closest('li'),
        type = '';

    // centered picture
    if (target.hasClass('markItUpButton13')) {
      type = 'center';

      $('.wysiwyg-popup.picture > .title').html('Центральная картинка');
    }

    // left-aligned picture
    if (target.hasClass('markItUpButton14')) {
      type = 'left';

      $('.wysiwyg-popup.picture > .title').html('Левая картинка');
    }

    // fullwidth picture
    if (target.hasClass('markItUpButton15')) {
      type = 'bpic';

      $('.wysiwyg-popup.picture > .title').html('Картинка без фона');
    }

    $('.wysiwyg-popup.picture').fadeIn(200).data('type', type);
  });

  // popup 'Choose Warn' - toggle and combobox-engine
  $('.markItUpButton18').on('click', function(e) {
    e.preventDefault();

    $('.wysiwyg-popup').fadeOut(200);
    $('.wysiwyg-popup.warn').fadeIn(200).data('type', type);

    $('.wysiwyg-popup.warn select').on('change', function(e) {
      var selected = $(this).find('option:selected'),
          name = selected.attr('class'),
          value = selected.text();

      $('.wysiwyg-popup.warn .current').html(value).data('room', 'name');
    })
  });

  // popup 'Choose Warn' - append chosen warn to editor
  $('.wysiwyg-popup.warn .add a').on('click', function(e) {
    e.preventDefault();

    var selectedRoom = $('.wysiwyg-popup.warn select option:selected'),
        id = selectedRoom.val(),
        name = selectedRoom.text(),
        code = '<p> ([ warn_' + id + '_' + name + '_banner ]) </p>';

    $.markItUp({ name:"Image", replaceWith:code });

    // closing
    $('.wysiwyg-popup.warn .close').click();
  });

  // Block of Code
  $('.markItUpButton22').on('click', function(e) {
    e.preventDefault();

    $('.wysiwyg-popup').fadeOut(200);
    $('.wysiwyg-popup.block-of-code').fadeIn(200).data('type', type);

    $('.wysiwyg-popup.block-of-code select').on('change', function(e) {
      var selected = $(this).find('option:selected'),
          name = selected.attr('class'),
          value = selected.text();

      $('.wysiwyg-popup.block-of-code .current').html(value).data('room', 'name');
    })
  });

  $('.wysiwyg-popup.block-of-code .add a').on('click', function(e) {
    e.preventDefault();

    var selectedBlock = $('.wysiwyg-popup.block-of-code select option:selected'),
        id = selectedBlock.val(),
        name = selectedBlock.text(),
        code = '<p> ([ block_of_code_' + id + '_' + name + '_code_of_block ]) </p>';

    $.markItUp({ name:"Image", replaceWith:code });

    // closing
    $('.wysiwyg-popup.block-of-code .close').click();
  });

   // popups 'Insert picture' - adding picture
  var addMedia = $('input#add-media');
  var removeMedia = $('.field.pict .remove');

  $('.add-media').on('change', addMediaFile);
  $('.wysiwyg-popup.picture .add a').on('click', addToPost);
  removeMedia.on('click', removeMediaFile);

  function addToPost(e) {
    e.preventDefault();

    var url = $('.field.pict').data('url'),
        alt = $('.field.alt input').val(),
        title = $('.alt-title .field.title input').val(),
        description = $('.field.description textarea').val();

    if (url.length == 0) return;

    var type = $('.wysiwyg-popup.picture').data('type');

    if (type == 'left') {
      var template = '<div class="l-pic"><img alt="' + alt + '" title="' + title + '" src="' + url + '" itemprop="url"><span class="caption">' + description + '</span></div>';
    }

    if (type == 'center') {
      var template = '<div class="c-pic"><img alt="' + alt + '" title="' + title + '" src="' + url + '" itemprop="url"><span class="caption">' + description + '</span></div>';
    }

    if (type == 'bpic') {
      var template = '<div class="b-pic"><img alt="' + alt + '" title="' + title + '" src="' + url + '" itemprop="url"><span class="caption">' + description + '</span></div>';
    }

    $.markItUp({ name:"Image", replaceWith:template });

    $('.wysiwyg-popup.picture').fadeToggle(200);
  }

  function addMediaFile(e) {
    var file = this.files[0];
    var reader = new FileReader();

    $('.field.pict .filename').html( file.name )

    reader.onerror = function(stuff) {
      console.log("error", stuff)
      console.log (stuff.getMessage())
    }

    reader.onload = function(e) {
      var result = e.target.result,
          url = '/upload/create_image';

      $.post(url, { fdata: result, fname: file.name }, function(data) {

        if (data.result == 'ok') {
          var fileName = file.name,
              url = data.url,
              id = data.id;

          $('.field.pict').data('url', url);
          $('.field.pict').data('id', id);

          alert('Загрузка файла завершена');
        } else {
          alert('shit!');
        }
      });
    }

    reader.readAsDataURL(file);
  }

  // popups 'Insert picture' - removing picture
  function removeMediaFile(e) {
    e.preventDefault();

    var target = e.target,
        field = $(target).parent(),
        id = field.data('id'),
        url = field.data('url'),
        url = '/upload/destroy';

    $.post(url, { id: id }, function(data) {

      if (data.result = 'ok') {
        $('.field.pict .filename').html('');
      } else {
        alert('shit!');
      }

    });
  }

  // close popups
  $('.wysiwyg-popup a.close').on('click', function(e) {
    e.preventDefault();

    var popup = $(this).closest('.wysiwyg-popup'),
        field = popup.find('input:file');

    field.replaceWith(field.val('').clone(true));

    popup.fadeOut(200);
  });


  $('a[href="#geo-form"]').on('click', function(e) {
    e.preventDefault();

    var
      el           = $(this).attr('href'),
      stickyHeight = $('.sticky-panel').innerHeight() || 0,
      position     = 0;

    if (el && el.length) {
      position = $(el).parents('.geo-form-block').offset().top;
      $('html, body').animate({scrollTop: position - stickyHeight}, 500);
    }
  });

  function show_modal() {
    var modal = $('.geo-modal-success');

    $('.overlay').show().fadeTo(100, 1, function() {
      modal.show().fadeTo(100, 1, function(){
        modal.addClass('visible').trigger('shown');
      });
    });
  }

  function close_modal() {
    var modal = $('.geo-modal-success');
    modal.animate({opacity: 0}, 400, function() {
      $(this).hide().trigger('hidden');
        $('.overlay').animate({opacity: '0'}, 400, function() {
          $(this).hide();
        });
    });
  }

  $(document).on('click', '.overlay', function() {
    close_modal();
  });

  $('#geo-form').on('ajax:success', function(e, data, status, xhr) {
    show_modal();
  });
}
